import React from 'react'
import './WorkExperience.css'
import { BiCheck, BiFontSize } from 'react-icons/bi'
import IMG111 from '../../assests/GAVS.png'
import IMG112 from '../../assests/D2k.png'

const WorkExperience = () => {
  return (
    <section id='services_workExp'>
      <br></br><br></br><br></br>
      <h2>Work Experience</h2>
      <div className='container service_container_workExp'>
        <article className="services_work_exp">
          <div className="service_head_workExperience" style={{ backgroundImage: `url(${IMG111})` }} >
          </div>

          <h2>GS Labs | GAVS</h2>
            <h4>Software Developer</h4>
          <ul className='service_list'>
            <li>  
              <p>Worked on the Human Resource and Payroll (HRP) project, contributing to Administrator Maintenance, Employee SelfService (ESS), and Manager Self-Service (MSS) portals.
              </p>
            </li>
            <li>
              <p>Resolved and closed 80+ tickets spanning stored procedures, 10+ RESTful APIs, and frontend UI components.</p>
            </li>
            <li>
              <p>Optimized application performance by 20% while ensuring code quality through unit test coverage.
              </p>
            </li>
            <li>
              <p>Contributed to Agile Scrum ceremonies including sprint planning, daily stand-ups, and retrospectives.
              </p>
            </li>
            <li>
              <p>Handled client queries, discussed business requirements, and presented code fixes through detailed technical walkthroughs.
              </p>
            </li>
            <li>
              <p>Tech Stack: Angular, .NET WebAPI, MS SQL, and Azure.
              </p>
            </li>
          </ul>
        </article>

        <article className="services_work_exp">
          <div className="service_head_workExperience" style={{ backgroundImage: `url(${IMG112})` }} >
          </div>
          <h2>D2k Technologies</h2>
            <h4>Software Developer</h4>
          <ul className='service_list'>
            <li>
              <p>Worked on fintech solutions for Punjab National Bank (PNB), building scalable and performance-critical modules handling large datasets.
              </p>
            </li>
            <li>
              <p>Assisted in bug fixing and issue resolution, ensuring application stability and better user experience.</p>
            </li>
            <li>
              <p>Gained hands-on experience in Linux environments and Nginx server setup for deployment and issue handling.</p>
            </li>
            <li>
              <p>Worked on data processing and reporting functionalities, improving accuracy and performance of financial data handling.</p>
            </li>
            <li>
              <p>Developed and enhanced features using .NET MVC, Angular, and MS SQL, ensuring smooth data flow and UI integration.</p>
            </li>
            <li>
              <p>Tech Stack: .NET MVC, Angular, MS SQL, Linux, Nginx.
              </p>
            </li>
          </ul>
        </article>

      </div>
    </section>
  )
}

export default WorkExperience